import { HubOutlined } from '@mui/icons-material';
import { SupplierIntegrationsPage } from '../modules/supplier-integrations';
import { RouteType } from './types';
import { routePaths } from './routePaths';

const SupplierIntegrations: RouteType = {
  exact: true,
  icon: HubOutlined,
  path: routePaths.supplierIntegrations,
  title: 'Supplier Integrations',
  component: () => <SupplierIntegrationsPage />,
  permission: 'canManageSupplierIntegrations',
};

export default SupplierIntegrations;
